export function loadScript(url, { attributes = {} } = {}) {
    return new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.onload = () => setTimeout(resolve, 0);
        script.onerror = reject;

        Object.entries(attributes).forEach(([key, value]) => {
            switch (typeof value) {
                case 'boolean':
                    script[key] = value;
                    break;
                default:
                    script.setAttribute(key, value);
            }
        });

        script.src = url;
        document.body.appendChild(script);
    });
}
